"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonSlideTaskRadioList = void 0;
var enums_1 = require("./enums");
/**
 * Слайд задания типа "список вариантов" и только один вариант правильный
 */
var LessonSlideTaskRadioList = /** @class */function () {
  function LessonSlideTaskRadioList() {
    this.type = enums_1.LessonSlideContentTypeEnum.TaskRadioList;
  }
  return LessonSlideTaskRadioList;
}();
exports.LessonSlideTaskRadioList = LessonSlideTaskRadioList;
